export default __webpack_public_path__ + "static/media/INHOUSE.da3f1513.gif";